export default __webpack_public_path__ + "static/media/more-horizontal.2cdf94c5.svg";